import request from '@/utils/request';

// 角色列表
export const rolelist = (data: any): any =>
  request({
    url: '/pc/employeeRole/list',
    data: data
  })

// 菜单列表
export const getMenuPermission = (data: any): any =>
  request({
    url: '/pc/employee/getMenuPermission',
    data: data
  })

// 角色详情
export const roleDetail = (data: any): any =>
  request({
    url: '/pc/employeeRole/detail',
    data: data
  })

// 角色编辑保存
export const roleSave = (data: any): any =>
  request({
    url: '/pc/employeeRole/save',
    data: data
  })

// 角色删除
export const roleDelete = (data: any): any =>
  request({
    url: '/pc/employeeRole/delete',
    data: data
  })
  
  
// 员工列表
export const employeeList = (data: any): any =>
  request({
    url: '/pc/employee/list',
    data: data
  })

// 员工详情
export const employeeDetail = (data: any): any =>
  request({
    url: '/pc/employee/detail',
    data: data
  })
  
// 新增员工
export const employeeSave = (data: any): any =>
  request({
    url: '/pc/employee/save',
    data: data
  })
  
// 编辑员工
export const employeeEdit = (data: any): any =>
  request({
    url: '/pc/employee/edit',
    data: data
  })

// 员工离职
export const employeeResign = (data: any): any =>
  request({
    url: '/pc/employee/resign',
    data: data
  })

// 员工重置密码
export const employeeResetPwd = (data: any): any =>
  request({
    url: '/pc/employee/resetPwd',
    data: data
  })



// 获取直播配置
export const livemallLiveConfig = (data: any): any =>
  request({
    url: '/pc/live/mallLiveConfig',
    data: data
  })
// 获取直播间下拉选项
export const liveliveRoomSelectItem = (data: any): any =>
  request({
    url: '/pc/live/liveRoomSelectItem',
    data: data
  })

// 直播配置保存
export const livemallLiveConfigSave = (data: any): any =>
  request({
    url: '/pc/live/mallLiveConfigSave',
    data: data
  })


// 客服账号列表
export const qyWeixinKfAccountqyWeixinKfAccountList = (data: any): any =>
request({
  url: '/pc/qyWeixinKfAccount/qyWeixinKfAccountList',
  data: data
})
// 客服帐号-同步
export const qyWeixinKfAccountsync = (data: any): any =>
request({
  url: '/pc/qyWeixinKfAccount/sync',
  data: data
})
// 删除客服账号
export const qyWeixinKfAccountqyWeixinKfAccountDelete = (data: any): any =>
request({
  url: '/pc/qyWeixinKfAccount/qyWeixinKfAccountDelete',
  data: data
})
// 获取客服账号信息
export const qyWeixinKfAccountqyWeixinKfAccountInfo = (data: any): any =>
request({
  url: '/pc/qyWeixinKfAccount/qyWeixinKfAccountInfo',
  data: data
})
// 查询负责团队
export const qyWeixinKfAccountqyWeixinKfAccountTeamByName = (data: any): any =>
request({
  url: '/pc/qyWeixinKfAccount/qyWeixinKfAccountTeamByName',
  data: data
})
// 客服账号保存
export const qyWeixinKfAccountqyWeixinKfAccountInfoSave = (data: any): any =>
request({
  url: '/pc/qyWeixinKfAccount/qyWeixinKfAccountInfoSave',
  data: data
})

// 获取员工负责的供应商列表
export const employeeChargeProvider = (data: any): any =>
request({
  url: '/pc/employee/chargeprovider',
  data: data
})
// 员工负责的供应商-保存
export const employeeChargeProviderSave = (data: any): any =>
request({
  url: '/pc/employee/chargeprovidersave',
  data: data
})

// 员工是否用运费结算模板配置权限编辑 
export const employeeisHaveFreightSettlementTemplateLimit = (data: any): any =>
request({
  url: '/pc/employee/isHaveFreightSettlementTemplateLimit',
  data: data
})



// 获取商户商详页配置 
export const mallmallProductDetailInfo = (data: any): any =>
request({
  url: '/pc/mall/mallProductDetailInfo',
  data: data
})
// 获取商户商详页配置保存 
export const mallmallProductDetailInfoSave = (data: any): any =>
request({
  url: '/pc/mall/mallProductDetailInfoSave',
  data: data
})



// 会员注册配置保存 
export const memberRegistrationConfigsave = (data: any): any =>
request({
  url: '/pc/memberRegistrationConfig/save',
  data: data
})
// 会员注册配置初始化
export const memberRegistrationConfiginit = (data: any): any =>
request({
  url: '/pc/memberRegistrationConfig/init',
  data: data
})


// 员工是否有导出订单成本价配置权限
export const employeeisHaveExportOrderListCostPriceLimit = (data: any): any =>
  request({
    url: '/pc/employee/isHaveExportOrderListCostPriceLimit',
    data: data
  })



// 七鱼客服账号列表
export const qiyuKfAccountList = (data: any): any =>
  request({
    url: '/pc/qiyuKFAccount/list',
    data: data
})
// 七鱼客服账号同步
export const qiyuKfAccountSync = (data: any): any =>
  request({
    url: '/pc/qiyuKFAccount/sync',
    data: data
})
// 七鱼客服账号信息
export const qiyuKfAccountInfo = (data: any): any =>
  request({
    url: '/pc/qiyuKFAccount/info',
    data: data
})
// 七鱼客服账号保存
export const qiyuKfAccountSave = (data: any): any =>
  request({
    url: '/pc/qiyuKFAccount/save',
    data: data
})